import styled from "styled-components";
import SectionTitle from "./SectionTitle";
import { useMemo } from "react";
import Slider from "react-slick";
import FadeInItem from "./FadeInItem";
import { BREAK_POINT } from "../constants";

const Trailer = () => {
  const videos = useMemo(
    () => [
      { id: "SRUS7CD6IZQ", si: "7hck1Q-vpzJIXSra" },
      { id: "t8fdT4SsQao", si: "RYRC2Z0rhg13a4em" },
      { id: "Om4PwDH38RI", si: "tj3Ml1SLvuEJRhsD" },
      { id: "u8O94DdMiC0", si: "bZYOz9jVOfNtD0u6" },
    ],
    []
  );

  const sliderSetting = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    pauseOnHover: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (currentSlider: number) => {
      const nonActiveIframes = document.querySelectorAll(
        ".slick-slide iframe"
      ) as NodeListOf<HTMLIFrameElement>;
      nonActiveIframes.forEach((iframe) => (iframe.src = ""));

      const videoUrl = `https://www.youtube.com/embed/${videos[currentSlider].id}?si=${videos[currentSlider].si}&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=${videos[currentSlider].id}`;
      const currentIframe = document.querySelector(
        ".slick-current iframe"
      ) as HTMLIFrameElement;

      currentIframe.src = videoUrl;
    },
  };

  const videoStart = () => {
    const youtubeIframe = document.querySelector(
      ".slick-current iframe"
    ) as HTMLIFrameElement;
    if (youtubeIframe && !youtubeIframe.src.includes("youtube")) {
      const videoUrl = `https://www.youtube.com/embed/${videos[0].id}?si=${videos[0].si}&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=${videos[0].id}`;
      youtubeIframe.src = videoUrl;

      setTimeout(() => {
        youtubeIframe.style.backgroundColor = "transparent";
      }, 400);
    }
  };

  return (
    <Wrapper id="trailer">
      <SectionTitle>TRAILER</SectionTitle>
      <FadeInItem callback={videoStart} point={0.25}>
        <Slider {...sliderSetting}>
          {videos.map((video) => (
            <IframeWrapper key={video.id}>
              <iframe
                src=""
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </IframeWrapper>
          ))}
        </Slider>
      </FadeInItem>
    </Wrapper>
  );
};

export default Trailer;

const Wrapper = styled.div`
  width: 100%;
  padding: 140px 0 0;

  .slick-slider {
    width: 80%;
    max-width: 980px;
    margin: 100px 0 272px;
    border: 10px solid var(--white);
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }

  .slick-dots {
    bottom: -82px;

    li {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: var(--palePink);
      margin: 0 14px;

      &.slick-active {
        background: var(--primary);
      }
    }

    button {
      opacity: 0;
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    padding: 80px 0 0;

    .slick-slider {
      margin: 25px 0 100px;
    }

    .slick-dots {
      bottom: -52px;

      li {
        width: 10px;
        height: 10px;
      }
    }
  }
`;

const IframeWrapper = styled.div<{ $isMain?: boolean }>`
  position: relative;
  width: 100%;
  float: none;
  clear: both;
  height: 0;
  padding-bottom: 56.25%;
  background: var(--black);
  display: flex;
  justify-content: center;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    background-color: var(--black);
    margin: 1px;
  }

  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 70%;
    clip-path: polygon(
      0% 0%,
      0% 100%,
      44% 100%,
      44% 49%,
      56% 49%,
      56% 67%,
      0% 67%,
      0% 100%,
      100% 100%,
      100% 0%
    ); // show play button
  }

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 25%;
    height: 70%; // show controls
    clip-path: polygon(
      0% 0%,
      0% 100%,
      44% 100%,
      44% 49%,
      56% 49%,
      56% 67%,
      0% 67%,
      0% 100%,
      100% 100%,
      100% 0%
    ); // show play button
  }
`;
